import React, { Component } from 'react'
import { Button, Popup, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import "./Toolbar.css";
import { withRouter } from 'react-router-dom';
import LoadingComponent from '../../../common/LoadingComponent';

class ToolbarOrganization extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setDisable: false
        }
        this.deleteSubOrgMain = this.deleteSubOrgMain.bind(this);
    }

    createSubOrg = async (e) => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.organizationUnit.landingPageFlagSet(false);
        dispatch.lifeCycle.splitAt("60%")
        if (this.props.selectedSubOrg === null) {
            await dispatch.organizationUnit.getOrgByIdAsync(this.props.selectedOrganisation.id);
        }

        const { history } = this.props;
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/createTeam/addTeamToolbar/${this.props.selectedSubOrg._id}/${this.props.selectedSubOrg.parentOrganizationId ? this.props.selectedSubOrg.parentOrganizationId : this.props.selectedOrganisation.id}`);
    }

    addAndInviteUsers = async (e) => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.organizationUnit.showResourecePane(null);
        dispatch.lifeCycle.splitAt("60%")
        if (this.props.selectedSubOrg === null) {
            await dispatch.organizationUnit.getOrgByIdAsync(this.props.selectedOrganisation.id);
        }
        dispatch.community.setAddUserContextData('Users');
        const { history } = this.props;
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/addUser/addUserToolbar/${this.props.selectedSubOrg._id}/${this.props.selectedSubOrg.parentOrganizationId ? this.props.selectedSubOrg.parentOrganizationId : this.props.selectedOrganisation.id}`);
    }

    async deleteSubOrgMain() {
        try {
            await dispatch.organizationUnit.checkSuborganizationBeforeDelete(this.props.selectedSubOrg._id);
            // this.setState({ processingDelete: true });
            let message = <div className="confirmMessage">
                <h3>Delete Team</h3>
                <label>{this.props.selectedSubOrg.name}</label>
                <p>Are you sure that you wish to delete this team?</p>
                <span >This action is not reversible</span>
            </div>
            
            toastr.confirm(message, {
                onOk: async () => {
                    this.setState({ processingDelete: true });
                    await dispatch.organizationUnit.deleteSubOrganizationMainAsync(this.props.selectedSubOrg);
                    this.setState({ processingDelete: false });
                }
            });
            this.setState({ processingDelete: false });
        }
        catch (err) {
            const toastrConfirmOptions = {
                disableCancel: true
            };
            toastr.confirm(err.message, toastrConfirmOptions, {
                onOk: () => {
                }
            });
            this.setState({ processingDelete: false });
        }


    }

    fileUploaded = async (data) => {

        if (data.target.files[0].name.split('.').pop() === 'team') {
          this.setState({ processing: true })
          var fileToLoad = data.target.files[0];
          var fileReader = new FileReader();

            fileReader.onload = async (fileLoadedEvent) => {
                if (fileLoadedEvent.currentTarget.result === '') {
                    toastr.error('Message', 'Invalid File.');
                    // stopLoader();
                    this.setState({ processing: false })
                    return;
                }
                if (fileLoadedEvent.target.result !== "undefined") {
                    await dispatch.organizationUnit.importTeam({
                        data: fileLoadedEvent.target.result,
                        accountId: this.props.selectedAccount._id,
                        organizationId: this.props.selectedOrganisation.id
                    });
                    //   stopLoader();
                    this.setState({ processing: false })
                } else {
                    toastr.error('Message', 'Invalid File.');
                    // stopLoader();
                    this.setState({ processing: false })
                }
            };
    
          fileReader.readAsText(fileToLoad, "UTF-8");
        //   data.target.value = null;
        } else {
          toastr.error('Message', 'Invalid File.');
        }
    
      }

    getTeamToExport = async () => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    
        let message = <div className="confirmMessage">
          <h3>Export Team</h3>
          <label>Teams - {this.props.selectedSubOrg.name}</label>
          <p>Are you sure you want to export this Team?</p>
          <p>Team name, description and custom attributes will be exported along with this team. Playbook & Initiative data won’t be exported.</p>
          {/* <span style={{ color: "#a9a9a9" }}>This action will not export comments and attachments added at playbook/activity level.</span> */}
        </div>
        toastr.confirm(message, {
          okText: 'Export ',
          onOk: async () => {
            let payload = {
                "teamId": this.props.selectedSubOrg._id,
                "name": this.props.selectedSubOrg.name
            }
            await dispatch.organizationUnit.getSuborganizationToExport(payload);
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.props.teamToExport));
            
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(dataStr);
            }
            else {
              //for firfox/chrome
              let link = document.createElement('a');
              link.href = dataStr;
              link.download = this.props.selectedSubOrg.name + '.team';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        });
    }

    getTeamToImport = async () => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
    
        let message = <div className="confirmMessage">
          <h3>Import Team</h3>
          <label>Teams - {this.props.selectedSubOrg.name}</label>
          <p>You already have teams under your WS. If you wish to import new teams, please delete existing teams.</p>
          {/* <span style={{ color: "#a9a9a9" }}>This action will not export comments and attachments added at playbook/activity level.</span> */}
        </div>
        toastr.confirm(message, {
          onOk: async () => {
          }
        });
    }

    removeUser = async (e) => {
        if (this.props.orgUniqueId.toString() === this.props.selectedOrganisation.id.toString()) {
            let payload = {};
            payload.accountUserId = this.props.userObj._id;
            payload.organisationId = this.props.selectedOrganisation.id;
            payload.subOrgId = this.props.orgUniqueId;
            dispatch.users.getdeactivateuserdetails(payload)
            dispatch.users.userDeactivateModal(true);
        } else {
            let deletesuborgObj = Object.assign({}, this.props.userObj);
            deletesuborgObj.role = this.props.userObj.role;
            deletesuborgObj.subOrgName = this.props.selectedSubOrg.name;
            deletesuborgObj.subOrgId = this.props.selectedSubOrg._id;
            deletesuborgObj.type = 'deleteUserFromToolbar';
            deletesuborgObj.organisation = this.props.selectedSubOrg.name;
            dispatch.users.addUserToDelete(deletesuborgObj);
            dispatch.users.userDelModalOpen(true);
        }
    }

    deleteInvitation = async (e) => {
        try {
            let userdata = this.props.inviteUserList
            let message = <div className="confirmMessage">
                <h3>Delete invitation</h3>
                <label>{this.props.inviteUserList.firstName + ' ' + this.props.inviteUserList.lastName}</label>
                <p>Are you sure that you wish to delete this Invitation?</p>
                <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    await dispatch.invite.deleteInvitaionAsync(userdata);
                    if (userdata.organisationId == userdata.referenceId) {
                        dispatch.initiatives.getInviteBySubOrgAsync(userdata.referenceId)
                    }
                    else {
                        let query = {
                            $sort: { createdAt: 1 },
                            $skip: 0,
                        }
                        let payload = {
                            query: query,
                            organizationId: userdata.organisationId,
                            referenceId: userdata.referenceId
                        };
                        await dispatch.invite.getInvitesAsync(payload);
                    }
                    dispatch.organizationUnit.showResourecePane(null);
                    dispatch.organizationUnit.showDeleteDisabled(false)
                }
            });
        }
        catch (err) {
        }

    }

    resendInvitation = async (e) => {
        let message = <div className="confirmMessage">
            <h3>Resend Invitation</h3>
            <label>{this.props.inviteUserList.email}</label>
            <p>Are you sure that you wish to resend this invitation?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let organizationObj = {
                    "name": this.props.selectedSubOrg ? this.props.selectedSubOrg.name : this.props.selectedOrganisation.name,
                    "entityName":  this.props.selectedOrganisation && this.props.selectedSubOrg && this.props.selectedOrganisation.id.toString() !== this.props.selectedSubOrg._id.toString() ?
                        "Team" : 'Workspace'
                }
                let subject = this.props.selectedOrganisation && this.props.selectedSubOrg && this.props.selectedOrganisation.id.toString() !== this.props.selectedSubOrg._id.toString() ?
                    `You have been Invited to join the "${this.props.selectedSubOrg.name}" Team for "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`
                    : `You have been Invited to join the "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`
                let emailObject = {
                    templateName: "resendInviteMail",
                    toEmail: this.props.inviteUserList.email,
                    invite: this.props.inviteUserList,
                    invitationCode: this.props.inviteUserList._id,
                    fromUser: this.props.user,
                    organization: organizationObj,
                    subject: subject
                }
                emailObject.organizationId = this.props.selectedOrganisation.id;
                dispatch.invite.resendInvitation(emailObject);
            }
        });

    }

    teamView = async (value) => {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        await dispatch.organizationUnit.showResourecePane(null);
        dispatch.organizationUnit.showDeleteDisabled(true)
        if (this.props.mainAreaContext === "ORGANIZATION") {
            if (this.props.selectedSubOrg && this.props.selectedSubOrg.parentOrganizationId) {
                dispatch.users.storeUnitId(this.props.selectedSubOrg.parentOrganizationId);
            } else {
                dispatch.users.storeUnitId(this.props.selectedOrganisation.id);
            }
        }
        dispatch.app.showTeamListView(value)
    }

    render() {
        let orgId = this.props.match.url.split("/")
        let teamExists = this.props.selectedSubOrg && (this.props.selectedSubOrg.parentOrganizationId) ? true : false;
        teamExists = this.props.selectedSubOrg && (!this.props.selectedSubOrg.parentOrganizationId && this.props.selectedSubOrg.subOrganizations && this.props.selectedSubOrg.subOrganizations.length==0) ? false : true;
        return (
            <div>
                
                <LoadingComponent active={this.state.processing} message="Importing Team..."/>
                <LoadingComponent active={this.state.processingDelete} message="Deleting Team..."/>

                {this.props.showToolbarFlag ?
                    <div className="toolBar header_buttons">
                        {this.props.mainAreaContext === "ORGANIZATION" ?
                            <Button.Group size='mini' className="mar_Right_5">
                                <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Add Team")}>
                                    <Button icon='plus' className="clr-blue"
                                        onClick={this.createSubOrg}
                                        disabled={this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id}
                                    />

                                </span>}
                                    content='Add Team'
                                />
                                {/* {teamExists ?
                                <Popup inverted
                                className="popupStyled" trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Import Team")}>
                                    <Button
                                    icon={<Icon name='cloud upload' onClick={this.getTeamToImport} className={`f_16 ${this.props.activePageTab == 'importTeam' ? "clr-light-blue" : "clr-blue"}`} />}
                                    className="clr-green"
                                    /></span>
                                }
                                flowing
                                hoverable
                                on="hover"
                                content='Import Team'
                            ></Popup>: ""} */}
                            
                                <Popup inverted className="popupStyled z-index-999" trigger={
                                            <label className={this.props.activePageTab == 'importTeam' ? "disabledImportIcon" : "exportIcon"}>
                                            <Icon name='cloud upload' className={`f_16 ${this.props.activePageTab == 'importTeam' ? "clr-light-blue" : "clr-blue"}`} onMouseEnter={() => dispatch.app.setHelpContext("Import Team")} style={{ verticalAlign: "top", margin: "-2px 0 0 0" }} />
                                            <input type="file" name="file" id="file" className="inputfile" onChange={(e) => this.fileUploaded(e)} accept=".team"/>
                                            </label>
                                        }
                                            content='Import Team'
                                        />
                                <Popup inverted className="popupStyled"
                                    trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Export Team")}>
                                        <Button
                                        icon={<Icon name='cloud download' onClick={this.getTeamToExport} className="f_16" />}
                                        className="clr-green"
                                        disabled={!teamExists}
                                        /></span>
                                    }
                                    flowing
                                    hoverable
                                    on="hover"
                                    content='Export Team'
                                ></Popup>

                                {/* <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Delete Team")}>
                                    <Button icon='trash' className="clr-orange"
                                        onClick={this.deleteSubOrgMain}
                                        disabled={this.props.isDeleteDisabled || this.props.orgUniqueId === this.props.selectedOrganisation.id || this.props.collapsedResourcePaneIndexTemp === 0}
                                    />
                                </span>}
                                    content='Delete Team'
                                /> */}
                            </Button.Group>
                            : null}
                        {this.props.mainAreaContext === "USERS" ?
                            <Button.Group size='mini' className="mar_Right_5">

                                <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Add User")}>
                                    <Button icon='plus' className="clr-blue"
                                        onClick={this.addAndInviteUsers}
                                        disabled={this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id}
                                    />
                                </span>}
                                    content='Add / Invite User'
                                />


                                {this.props.userRole === 'Invitations' ?
                                    <React.Fragment>
                                        {/* <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Delete User")}>
                                            <Button icon='trash' className="clr-orange"
                                                onClick={this.deleteInvitation}
                                                disabled={!this.props.isDeleteDisabled || this.props.collapsedResourcePaneIndexTemp === 0 || (this.props.selectedSubOrg && this.props.selectedSubOrg.members ? this.props.selectedOrganisation.role === "Manager" && !this.props.selectedSubOrg.members.some(member => member.role == 'Manager' && member.accountUserId.toString() == this.props.user._id.toString()) : this.props.selectedOrganisation.role === "Manager" && orgId[4] === orgId[7])}
                                            />
                                        </span>}
                                            content={`Delete Invite from ${this.props.selectedSubOrg ? this.props.selectedSubOrg.name : 'workspace'}`}
                                        /> */}
                                        <Popup className="popupStyled" inverted trigger={<span>
                                            <Button icon='redo' className="clr-blue"
                                                onClick={this.resendInvitation}
                                                disabled={!this.props.isDeleteDisabled || this.props.collapsedResourcePaneIndexTemp === 0}
                                            />
                                        </span>}
                                            content={`Resend Invite from ${this.props.selectedSubOrg ? this.props.selectedSubOrg.name : 'workspace'}`}
                                        />
                                    </React.Fragment>
                                    : null
                                    // <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Delete User")}>
                                    //     <Button icon='trash' className="clr-orange"
                                    //         onClick={this.removeUser}
                                    //         disabled={!this.props.isDeleteDisabled || this.props.collapsedResourcePaneIndexTemp === 0 || (this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id) || (this.props.userObj && this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.length > 0 && this.props.selectedAccount.users.some(user => user.id && user.id._id && this.props.userObj._id && user.id._id.toString() === this.props.userObj._id.toString() && user.role === 'customerAdmin') && this.props.orgUniqueId === this.props.selectedOrganisation.id)}
                                    //     />  
                                    // </span>}
                                    //     content={`Remove User from ${this.props.selectedSubOrg ? this.props.selectedSubOrg.name : 'workspace'}`}
                                    // />
                                }

                            </Button.Group> :
                            null}
                        {this.props.mainAreaContext === "USERS" || this.props.mainAreaContext === "ORGANIZATION" ?
                            <Button.Group size='mini' className="mar_Right_5 float-right">
                                <Popup className="popupStyled" inverted trigger={<span>
                                    <Button icon='list' className={`${this.props.teamsListViewFlag ? "clr-green toggleOn" : "clr-green"}`}
                                        disabled={this.props.collapsedResourcePaneIndexTemp === 0}
                                        onClick={() => this.teamView(true)}
                                    />
                                </span>}
                                    content='List View'
                                />
                                <Popup className="popupStyled" inverted trigger={<span>
                                    <Button icon='grid layout' className={`${!this.props.teamsListViewFlag ? "clr-green toggleOn" : "clr-green"}`}
                                        disabled={this.props.collapsedResourcePaneIndexTemp === 0}
                                        onClick={() => this.teamView(false)}
                                    />
                                </span>}
                                    content='Grid View'
                                />
                            </Button.Group>
                            : ''}
                    </div> : ''}

                    
            </div>
        )
    }
}

export default withRouter(ToolbarOrganization)


